<template>
  <v-container v-if="error || errorDescription">
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="auto"
        class="mt-8 content"
      >
        <v-card class="root">
          <v-card-title>{{ $t('auth.error-messages.general-error') }}</v-card-title>

          <v-card-text v-if="errorDescription">
            <p>{{ errorDescription }}</p>
            <router-link :to="{ name: 'login' }">{{
              $t('auth.error-messages.login-link-text')
            }}</router-link>
          </v-card-text>

          <v-card-text v-else>
            <p>{{ $t('auth.error-messages.login-again') }}</p>

            <p>
              {{ $t('auth.error-messages.try-different-browser') }}
            </p>

            <router-link :to="{ name: 'login' }">{{
              $t('auth.error-messages.login-link-text')
            }}</router-link>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import * as Sentry from '@sentry/vue'

export default {
  computed: {
    error() {
      return this.$route.query.error
    },
    errorDescription() {
      return this.$route.query.error_description
    },
  },
  watch: {
    '$route.query': {
      handler(value) {
        const supportedKeys = ['error', 'error_description', 'code']
        const keys = Object.keys(value)
        if (keys.length === 0 || keys.every((key) => !supportedKeys.includes(key))) {
          // If user is logged instead of navigating to login page, it will be redirected to authenticated area like dashboard
          // As it is handled this way by vue-router
          Sentry.captureMessage('Invalid or empty query parameters in the callback route', {
            extra: { query: value, supportedKeys: supportedKeys },
          })
          this.$router.push({ name: 'login' })
        }
      },
      immediate: true,
    },
  },
}
</script>

<style scoped>
.content {
  width: 450px;
}
</style>
